import * as React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

// Shared Tier-1 impact warning + required acknowledgment, used by both the Confirm and Edit dialogs
// (design §7.2 #6). Renders nothing when there is no impact; the caller keeps the acknowledged state
// and disables its primary action until the box is checked. The affected seasons come straight from
// the server's impact payload — the UI never recomputes impact.
export default function EligibilityImpactAck({ impact, acknowledged, onChange }) {
  if (!impact || impact.count <= 0) return null;
  const n = impact.count;
  const plural = n === 1 ? "" : "s";

  const affected = impact.seasons.map((s) => (
    <li key={s.seasonid}>
      {s.seasonname} · {s.season_date}
      {s.trackingyear ? ` · TY ${s.trackingyear}` : ""}
    </li>
  ));

  return (
    <>
      <Alert severity="warning" sx={{ mb: 1 }}>
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          <strong>{n}</strong> accepted LK/SI season{plural} would fall outside this
          franchise&rsquo;s eligibility and stop being pulled by the Season Audit. (They remain
          visible as saved rows.)
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>{affected}</Box>
      </Alert>
      <FormControlLabel
        control={<Checkbox checked={acknowledged} onChange={(e) => onChange(e.target.checked)} />}
        label={`I understand ${n} accepted LK/SI season${plural} will fall outside eligibility.`}
      />
    </>
  );
}
